export const firstAnimations = ()=> {

    const heroMainSection = document.querySelectorAll('.hero-main')

    heroMainSection?.forEach(section=> {
        const heroBg = section.querySelector('.hero-main__bg')
        const heroElement = section.querySelector('.hero-main__element-wrapper')
        const heroText = section.querySelector('.hero-main__text')

        if (section) {
            if (heroBg) {
                heroBg.classList.add('play');
            }

            if (heroElement) {
                setTimeout(()=> {
                    section.querySelector('.hero-main__element').classList.add('play');
                },600)
            }

            if (heroText) {
                setTimeout(()=> {
                    heroText.classList.add('play');
                },700)
            }

        }

        const scrollAnim = ()=> {
            if (gsap.getById('heroScrollAnimation')) {
                gsap.getById('heroScrollAnimation').kill();
            }

            if (window.matchMedia("(min-width:1024px)").matches) {

                gsap.to('.hero-main__inner', {
                    id: 'heroScrollAnimation',
                    scrollTrigger: {
                        trigger: '.site-main',
                        start: `top top`,
                        end: `${window.innerHeight * 2}px bottom`,
                        scrub: true,
                        onLeave: ()=> {
                            section?.classList.add('hide')
                        },
                        onEnterBack: ()=> {
                            section?.classList.remove('hide')
                        },
                    },
                    scale: .4,
                    opacity: 0,
                })
            } else {
                document.querySelector('.hero-main__inner').style = 'opacity: 1;transform: scale(1);';
                document.querySelector('.hero-main__inner')?.classList.remove('hide');
                gsap.killTweensOf('.hero-main__inner');
            }
        }

        scrollAnim()

        window.addEventListener('resize',scrollAnim)

    })
}